import { DynamicCardProps, DynamicCardType } from "src/types";
import { usePvSection2 } from "./landing-pv-section2.hook";
import { DynamicCard } from "src/ui/widgets";

export const PvSection2 = () => {
  const { carouselProductList, nTileItemsPerRow, t } = usePvSection2();

  const Header = (
    <>
      <div className="pv-section2-title mb-3">{t("landing_pv.section2.title")}</div>
      <div className="font-20-roman">{t("landing_pv.section2.subtitle")}</div>
    </>
  );

  return (
    <div>
      {Header}
      <hr className="my-5" />
      <div className="d-flex flex-row flex-wrap">
        {carouselProductList.map((item: DynamicCardProps) => {
          const isTile = item.type === DynamicCardType.tile;
          if (isTile) ++nTileItemsPerRow.current;
          else nTileItemsPerRow.current = 0;
          const isThirdTile = isTile && nTileItemsPerRow.current % 3 === 0;

          return (
            <div
              key={item.carouselCode}
              className={`mb-5 ${!isTile ? "w-100" : "card-wrapper"} ${
                isThirdTile ? "no-margin" : ""
              }`}
            >
              <DynamicCard {...item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
